"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _textToDownloadActionKeys = _interopRequireDefault(require("./textToDownloadActionKeys"));

var _index = require("../../index");

var _redux = require("redux");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var TEXT_TO_DOWNLOAD_SEND_MEMBER_APP_LINK = _textToDownloadActionKeys.default.TEXT_TO_DOWNLOAD_SEND_MEMBER_APP_LINK,
    TEXT_TO_DOWNLOAD_SEND_MEMBER_APP_LINK_SUCCESS = _textToDownloadActionKeys.default.TEXT_TO_DOWNLOAD_SEND_MEMBER_APP_LINK_SUCCESS;

var _default = (0, _redux.combineReducers)({
  sendMemberAppLink: _index.AsyncRequest.createReducer(TEXT_TO_DOWNLOAD_SEND_MEMBER_APP_LINK, (0, _defineProperty2.default)({}, TEXT_TO_DOWNLOAD_SEND_MEMBER_APP_LINK_SUCCESS, function (state) {
    return _objectSpread(_objectSpread({}, state.toJSON()), {}, {
      isLoading: false,
      response: {
        success: true
      }
    });
  }))
});

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/textToDownload/textToDownloadReducer.js
// module id = 4436
// module chunks = 25